<template>
  <div class="order-detail">
    <div class="orderDetail_Brand">
      <div class="container brandTitle">
        <span @click="$router.push('/home')">{{$hs('首页','Home','En la primera página')}}</span> >
        <span @click="$router.push('/order')">{{$hs('我的订单','My Order','Mi pedido')}}</span>
        >
        {{$hs('订单详情','Order Details','Detalles del pedido')}}
      </div>
    </div>
    <div class="container tableListProduct">
      <div class="order-detail-container" v-if="Object.keys(orderInfo).length>0">
        <div class="order_info">
          <div class="order_infoperson">
            <div class="orderinfo_ContactPerson">
              <div class="label">{{$hs('联系人', 'Contact Person','contacto')}}</div>
              <div class="content">{{ orderInfo.createdUserName }}</div>
            </div>
            <div class="orderinfo_email">
              <div class="label">{{$hs('电子邮件', 'Email','Correo electrónico')}}</div>
              <div class="content">{{ orderInfo.createdUserEmail }}</div>
            </div>
            <div class="orderinfo_unit">
              <div class="label">{{$hs('采购单位', 'Purchase Unit','Unidad de compra')}}</div>
              <div class="content">{{ orderInfo.currency }}</div>
            </div>
          </div>
          <div class="orderinfo_Remarks">
            <div class="label">{{$hs('备注', 'Remarks','observaciones')}}</div>
            <div class="content">{{ orderInfo.orderRemark }}</div>
          </div>
        </div>
        <div class="order-detail-list" v-if="orderInfo.orderDetails.length>0">
          <el-table
            size="mini"
            ref="cartTable"
            :data="orderInfo.orderDetails"
            @select="selectRow"
            tooltip-effect="dark"
            @selection-change="selectionChange"
          >
            <el-table-column type="index" width="100" :label="$hs('ID', 'ID','ID')" align="center"></el-table-column>
            <el-table-column :label="$hs('图片', 'Picture','mágenes')" align="center" width="136">
              <template slot-scope="scope">
                <div class="pro-img">
                  <img
                    :src="scope.row.imgUrl || image"
                    alt
                    srcset
                    @click="$router.push({ path: '/proDetail', query: { coNu: scope.row.co_Nu } })"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('产品编号', 'Item NO.','Producto no.')" prop="co_Nu" align="center" width="114"></el-table-column>
            <el-table-column :label="$hs('产品详情', 'Description','Detalles del producto')" align="center">
              <template slot-scope="scope">
                <div
                  class="col name"
                  :title="$hs(scope.row.pr_Na,scope.row.pr_En_Na,scope.row.basicThreeLanguage)"
                >{{ $hs(scope.row.pr_Na,scope.row.pr_En_Na,scope.row.basicThreeLanguage) || ''}}</div>
                <!-- <div
                  class="col"
                >{{$hs('包装规格','PACKAGE')}}：{{ scope.row.in_Le || 0 }} x {{ scope.row.in_Wi || 0 }} x {{ scope.row.in_Hi || 0 }}CM</div>
                <div
                  class="col"
                >{{$hs('外箱规格','CARTON')}}：{{ scope.row.ou_Le || 0 }} x {{ scope.row.ou_Wi || 0 }} x {{ scope.row.ou_Hi || 0 }}CM</div>
                <div class="col">{{$hs('毛重/净重','G.W/N.W')}}：{{ scope.row.gr_We || 0 }} / {{ scope.row.ne_We || 0 }}KGS</div>-->
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$hs('价格','Price','precio')" width="94" align="center">
              <!-- <el-input v-model="formData.packThreeLanguage" placeholder="请输入内容" v-if="this.$i18n.locale == 'ru'"></el-input>
                  <el-input v-model="formData.en_Pa" placeholder="请输入内容" v-else-if="this.$i18n.locale == 'en'"></el-input>
              <el-input v-model="formData.ch_Pa" placeholder="请输入内容" v-else></el-input>-->
              <template slot-scope="scope">
                <div class="price">{{ userInfo.symbol }}{{ userInfo.status === 1 ? scope.row.price : $hs('查看价格','SIGN IN') }}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('包装方式', 'Packing','Forma de embalaje')" align="center">
              <template slot-scope="scope">
                <div>{{ $hs(scope.row.ch_Pa, scope.row.en_Pa, scope.row.packThreeLanguage)}}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('体积', 'CBM/CTN','volumen')" width="148" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.bulk_Stere }}CBM</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('总体积', ' T.CBM','Volumen total')" align="center">
              <template slot-scope="scope">
                <div>{{ Math.round(scope.row.bulk_Stere * scope.row.number * 1000) /1000 }}CBM</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('装箱量', 'QTY/CTN(Set)','Cantidad de contenedores')" align="center" width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.ou_Lo }}PCS</div>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="$t('LLH.CartOuterQTY') + '//(PCS)'" prop="packingCapacity" align="center" :render-header="renderheader">
              <template slot-scope="scope">{{ scope.row.ou_Lo }}</template>
            </el-table-column>-->
            <!-- <el-table-column :label="$t('LLH.CBM')" align="center" prop="bulk_Stere">
              <template slot-scope="scope">{{ scope.row.bulk_Stere }}</template>
            </el-table-column>-->
            <el-table-column :label="$hs('箱数','CTNS', 'Número de cajas')" prop="number" align="center" :render-header="renderheader">
              <template slot-scope="scope">
                <div>{{ scope.row.number }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$hs('合计价格','Total','Precio en total')"
              prop="total"
              :render-header="renderheader"
              align="center"
              width="124"
            >
              <template slot-scope="scope">
                <div class="price" style="color: #FF0000;">
                  <span>{{ userInfo.symbol }}{{ userInfo.status === 1 ? (scope.row.number * scope.row.price * scope.row.ou_Lo).toFixed(2) : '***'}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="submit-box">
            <div class="price">
              <!-- {{ $t('LLH.totalPrice')}}：
              <span>{{ userInfo.status === 1 ? (userInfo.symbol || '') + totalPrice : $t('LLH.ViewPrice')}}</span>-->
            </div>
            <div class="left">
              <div>
                <span>
                  {{$hs('产品数量','Total Records','Cantidad De Productos')}}:
                  <span>{{ orderInfo.orderDetails.length }}</span>
                </span>
              </div>
              <div>
                <span>
                  {{$hs('合计箱数','Total CTNS','Total De Cajas')}}:
                  <span>{{ totalNumber }}</span>
                </span>
              </div>
              <div>
                <span>
                  {{$hs('合计装箱量','Total Quantity','Cantidad Total De Contenedores')}}:
                  <span>{{ totalouLo }}PCS</span>
                </span>
              </div>
              <div>
                <span>
                  {{ $hs('合计价格','Total Price','Precio En Total') }}:
                  <span
                    style="color:#FF0000;font-weight: 700;"
                    v-if="userInfo.id"
                  >{{ userInfo.symbol }}{{totalPrice}}</span>
                  <span style="color:#FF6700;" v-else>***</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <el-empty :description="$t('noData')" v-else></el-empty>
      </div>
    </div>
    <div class="MobileTerminal_orderDetail">
      <div class="order_info">
        <div class="orderinfo_ContactPerson">
          <div class="label">{{$hs('联系人', 'Contact Person','contacto')}} :</div>
          <div class="content">{{ orderInfo.createdUserName }}</div>
        </div>
        <div class="orderinfo_email">
          <div class="label">{{$hs('电子邮件', 'Email','Correo electrónico')}} :</div>
          <div class="content">{{ orderInfo.createdUserEmail }}</div>
        </div>
        <div class="orderinfo_unit">
          <div class="label">{{$hs('采购单位', 'Purchase Unit','Unidad de compra')}} :</div>
          <div class="content">{{ orderInfo.currency }}</div>
        </div>
      </div>
      <div class="orderList">
        <div class="orderList_Items" v-for="(options,index) in orderInfo.orderDetails" :key="index">
          <div class="orderListItems_Images" @click="$router.push({ path: '/proDetail', query: { coNu: options.co_Nu } })">
            <img :src="options.imgUrl" alt />
          </div>
          <div class="orderListItems_ProductInfo">
            <div>{{ $hs(options.pr_Na,options.pr_En_Na,options.basicThreeLanguage) || '' }}</div>
            <div>{{ options.co_Nu }}</div>
            <div>
              <div class="info_price">￥{{ options.price }}</div>
              <div class="info_number">X{{ options.number }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOrderDetail } from '@/api/order'
import { GetMemberInfo } from '@/api/login'
import orderBox from './orderBox.vue'
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  name: 'pageOrderDetail',
  components: {
    orderBox
  },
  data() {
    return {
      orderInfo: {},
      formData: {
        gender: 0,
        source: '',
        job: '',
        company: '',
        tel: '',
        fax: '',
        qq: '',
        msn: '',
        skype: '',
        yahu: '',
        website: '',
        zipCode: '',
        country: '',
        userId: null,
        sysUserEmail: '',
        userAccount: '',
        userName: '',
        userPassword: '',
        userPasswordVerify: '',
        mobile: '',
        email: '',
        address: '',
        weChat: '',
        whatsApp: '',
        createdUserId: '',
        createdUserEmail: '',
        sysUserId: ''
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapState('operate', ['language']),
    // 总箱数
    totalNumber() {
      return this.orderInfo.orderDetails.reduce((total, item) => total + item.number, 0)
    },
    totalouLo() {
      return this.orderInfo.orderDetails.reduce((total, item) => total + (item.ou_Lo * item.number), 0)
    },
    // 总体积
    totalCMB() {
      return this.orderInfo.orderDetails.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.bulk_Stere * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总材积
    totalCUFT() {
      return this.orderInfo.orderDetails.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.bulk_Feet * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总毛重
    totalGW() {
      return this.orderInfo.orderDetails.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.gr_We * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总净重
    totalNW() {
      return this.orderInfo.orderDetails.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.ne_We * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },

    // 总价格
    totalPrice() {
      let totalPrice = 0
      let data = this.orderInfo.orderDetails
      data.forEach(item => {
        totalPrice += item.number * item.price * item.ou_Lo
      })
      return Math.round(totalPrice * 100) / 100
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    // 初始化
    async initData() {
      await this.getUserInfo()
      getOrderDetail({ orderNo: this.$route.query.orderNo })
        .then(res => {
          if (res.success) {
            this.orderInfo = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    renderheader(h, { column }) {
      // renderheader函数得用到el-table-column上
      return h('span', {}, [
        h('span', {}, column.label.split('//')[0]), // 其中//也可以用其他符号替代
        h('br'),
        h('span', {}, column.label.split('//')[1])
      ])
    },
    // 获取用户信息
    getUserInfo() {
      GetMemberInfo()
        .then(res => {
          if (res.success) {
            let info = res.data || {}
            this.formData = {
              ...this.formData,
              ...info.member,
            }

            this.set_userInfo(res.data)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0 !important;
}
.name {
  /* 旧版浏览器兼容 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* 显示行数（含省略号占一行） */
  -webkit-line-clamp: 2;
  overflow: hidden;
  /* 标准属性 */
  line-clamp: 4;
  max-height: 90px;
}
.order-detail {
  background-color: #fff;
  padding: 10px 0;
}
.orderDetail_Brand {
  width: 100%;
  height: 48px;
  .brandTitle {
    font-size: 14px;
    font-family: Arial, Arial-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 48px;
    span:hover {
      color: #ff6700;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.order-detail-container {
  min-height: 400px;
  border-radius: 4px;
  margin-bottom: 40px;
  // box-shadow: 0px 2px 2px 0px #dfdfdf, 0px 3px 6px 0px #dfdfdf inset;
  .order_info {
    background: #ffffff;
    border: 1px solid #e9e9e9;
    margin-top: 10px;
    margin-bottom: 20px;
    .order_infoperson {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 74px;
    }

    .orderinfo_Remarks {
      display: flex;
      align-items: flex-start;
      margin-left: 30px;
      margin-bottom: 20px;
      .label {
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: right;
        color: #999999;
        line-height: 14px;
        width: 100px;
        margin-top: 10px;
      }
      .content {
        width: 1025px;
        height: 62px;
        padding-left: 10px;
        padding-top: 8px;
        background: #fafafa;
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: left;
        color: #222222;
        margin-left: 10px;
      }
    }

    .orderinfo_ContactPerson {
      display: flex;
      align-items: center;
      margin-left: 30px;
      .label {
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: right;
        color: #999999;
        line-height: 14px;
        width: 100px;
      }
      .content {
        width: 270px;
        height: 34px;
        line-height: 34px;
        padding-left: 10px;
        background: #fafafa;
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: left;
        color: #222222;
        margin-left: 10px;
      }
    }
    .orderinfo_email {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: right;
        color: #999999;
        line-height: 14px;
        width: 80px;
      }
      .content {
        width: 270px;
        height: 34px;
        line-height: 34px;
        background: #fafafa;
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        margin-left: 10px;
        padding-left: 10px;
        font-weight: 400;
        text-align: left;
        color: #222222;
      }
    }
    .orderinfo_unit {
      display: flex;
      align-items: center;
      margin-right: 21px;
      .label {
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: right;
        color: #999999;
        line-height: 14px;
        width: 92px;
      }
      .content {
        width: 270px;
        height: 34px;
        line-height: 34px;
        padding-left: 10px;
        background: #fafafa;
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: left;
        color: #222222;
        margin-left: 10px;
      }
    }
  }
  .order-detail-list {
    border: 1px solid #e9e9e9;
    & .pro-img {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 96px;
      height: 72px;
      margin-left: 10px;

      & img {
        width: auto;
        height: auto;
        max-width: 96px;
        max-height: 72px;
      }
    }

    & .price {
      color: #e33c0b;
      font-weight: bold;
    }

    & .action-list {
      display: flex;
      justify-content: flex-end;
      padding-top: 20px;

      & .count {
        display: flex;
        align-content: center;

        & p {
          margin-left: 20px;
          text-align: right;

          & span {
            color: #ff3e3e;
            font-size: 18px;
            margin-left: 5px;
          }
        }
      }

      & .price {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        & span {
          color: #ff3e3e;
          font-size: 24px;
          font-weight: 700;
          margin-left: 5px;
        }
      }
    }
  }
}
.submit-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  border-radius: 2px;
  font-size: 14px;
  height: 86px;
  color: #222222;
  .left {
    display: flex;
    padding-right: 20px;
    > div {
      margin: 0 20px;
      span {
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: right;
        color: #222222;
        line-height: 33px;
      }
    }
  }

  button {
    min-width: 200px;
    height: 100%;
    font-size: 18px;
  }
}
.remarks-box {
  margin: 20px 0 0 0;
  .content-remark {
    font-size: 15px;
    line-height: 26px;
    letter-spacing: 0.1em;
  }
}

@media screen and (min-width: 750px) {
  .MobileTerminal_orderDetail {
    display: none;
  }
}

@media screen and (max-width: 750px) {
  .tableListProduct {
    display: none;
  }
  .orderDetail_Brand {
    // width: 7rem !important;
    width: 100%;
    background: #f5f5f5;
    .brandTitle {
      font-size: 0.24rem;
      font-family: Arial, Arial-Regular;
      font-weight: 400;
      text-align: left;
      color: #222222;
      span:hover {
        color: #ff6700;
        text-decoration: underline;
        cursor: pointer;
      }
      > span:nth-child(1) {
        margin-left: 0.3rem;
      }
    }
  }

  .MobileTerminal_orderDetail {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .order_info {
      width: 6.8rem;
      height: 3.16rem;
      background: #ffffff;
      border: 1px solid #e9e9e9;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
      font-size: 0.24rem;
      padding-top: 0.3rem;
      margin-top: 0.3rem;
      .orderinfo_ContactPerson,
      .orderinfo_email,
      .orderinfo_unit {
        display: flex;
        margin-bottom: 0.2rem;
        margin-right: 0.3rem;
        .label {
          width: 2.5rem;
          height: 0.72rem;
          line-height: 0.72rem;
          font-size: 0.24rem;
          font-family: Arial, Arial-Regular;
          font-weight: 400;
          text-align: right;
          color: #999999;
        }
        .content {
          width: 4.55rem;
          height: 0.72rem;
          line-height: 0.72rem;
          padding-left: 0.2rem;
          margin-left: 0.1rem;
          background: #fafafa;
        }
      }
    }
    .orderList {
      width: 6.8rem;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      padding-bottom: 0.2rem;
      background: #ffffff;
      border: 1px solid #e9e9e9;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
      .orderList_Items {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 2rem;
        .orderListItems_Images {
          width: 1.8rem;
          height: 1.45rem;
          margin-left: 0.3rem;
          border: 1px solid rgb(236, 234, 234);
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 1.8rem;
            max-height: 1.45rem;
          }
        }
        .orderListItems_ProductInfo {
          margin-left: 0.2rem;
          > div:nth-child(1) {
            width: 4.3rem;
            font-size: 0.28rem;
            font-weight: 400;
            text-align: left;
            color: #222222;
            overflow: hidden; /* 隐藏超出容器的内容 */
            /* 隐藏溢出内容 */
            overflow: hidden;
            /* 旧版浏览器兼容 */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            /* 显示行数（含省略号占一行） */
            -webkit-line-clamp: 2;
            /* 标准属性 */
            line-clamp: 2;
          }
          > div:nth-child(2) {
            font-size: 0.23rem;
            font-family: Arial, Arial-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            margin: 0.1rem 0;
          }
          > div:nth-child(3) {
            width: 4rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .info_price {
              font-size: 0.3rem;
              font-family: Arial, Arial-Bold;
              font-weight: 700;
              text-align: left;
              color: #e33c0b;
            }
            .info_number {
              font-size: 0.3rem;
              font-family: Arial, Arial-Bold;
              font-weight: 700;
              text-align: right;
              color: #999999;
            }
          }
        }
      }
    }
  }
}
</style>